<hfc-spinner *ngIf="isLoading"></hfc-spinner>

<form
  *ngIf="!isLoading && updatesForm && commsPreferences"
  [formGroup]="updatesForm"
  class="communication-preferences_form"
>
  <section class="update-container">
    <div class="update-container_header">
      <span class="card-header">{{ updatesTitle }}</span>
    </div>
    <ng-container *ngIf="isEssential; else optionalUpdateTemplate">
      <p class="update-container_row helpful-text">Necessary updates on your case.</p>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="Email (Required)"
          [checkboxFormControl]="importantControl('essentialEmail')"
          [isFormGroup]="true"
          [isDisabled]="isDisabled"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="Phone (Required)"
          [checkboxFormControl]="importantControl('essentialPhone')"
          [isFormGroup]="true"
          [isDisabled]="isDisabled"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="WhatsApp"
          [checkboxFormControl]="importantControl('essentialWhatsapp')"
          [isDisabled]="false"
          [isFormGroup]="true"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="Post"
          [checkboxFormControl]="importantControl('essentialPost')"
          [isDisabled]="false"
          [isFormGroup]="true"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_column">
        <p class="helpful-text">Preference Note (optional)</p>
        <textarea
          placeholder="Ie specific times you do not wish to be called."
          [formControl]="importantControl('preferenceNote')"
          maxlength="255"
        ></textarea>
      </div>
    </ng-container>
    <ng-template #optionalUpdateTemplate>
      <div class="update-container_row mortgage-market-row">
        <hf-custom-checkbox
          label="Mortgage market update email"
          [checkboxFormControl]="optionalControl('mortgageMarketUpdateEmail')"
          [isDisabled]="false"
          [isFormGroup]="true"
        ></hf-custom-checkbox>
        <span></span>
      </div>
      <span class="border-bottom"></span>
      <p class="update-container_row helpful-text">
        Additionally, I’m happy to be contacted regarding helpful information and offers.
      </p>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="Email"
          [checkboxFormControl]="optionalControl('nonEssentialEmail')"
          [isFormGroup]="true"
          [isDisabled]="false"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="Phone"
          [checkboxFormControl]="optionalControl('nonEssentialPhone')"
          [isDisabled]="false"
          [isFormGroup]="true"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="WhatsApp"
          [checkboxFormControl]="optionalControl('nonEssentialWhatsapp')"
          [isDisabled]="false"
          [isFormGroup]="true"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_row">
        <hf-custom-checkbox
          label="Post"
          [checkboxFormControl]="optionalControl('nonEssentialPost')"
          [isDisabled]="false"
          [isFormGroup]="true"
        ></hf-custom-checkbox>
      </div>
      <div class="update-container_row">
        <span (click)="unsubscribe()" class="unsubscribe-link">Unsubscribe</span>
      </div>
    </ng-template>
  </section>
</form>
